import { render } from "./ProvinceListComponent.vue?vue&type=template&id=5118d30d"
import script from "./ProvinceListComponent.vue?vue&type=script&lang=js"
export * from "./ProvinceListComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__